import React from "react";
import {OverlayTrigger, Tooltip} from 'react-bootstrap';

interface RegionsDisplayProps {
  mappings: string;
  showAll: boolean;
  toggleShow: () => void;
}

export const RegionsDisplay: React.FC<RegionsDisplayProps> = ({ 
  mappings, 
  showAll, 
  toggleShow 
}) => {
  if (!mappings || typeof mappings !== "string") return <span>--</span>;

  const regions = mappings.split(",");

  return (
    <>
      <span className="badge px-3 rounded-pill me-2" style={{ border: "1px solid #E1E1E1" }}>
        {regions[0].trim()}
      </span>

      {regions.length > 1 && !showAll && (
        <OverlayTrigger
          placement='right'
          popperConfig={{
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, 8],
                },
              },
            ],
          }}
          overlay={
            <Tooltip id='tooltip-frameworks' style={{ whiteSpace: 'pre-line', textAlign: 'left' }}>
              <span style={{fontSize:'12px', display: 'block', textAlign: 'left'}} className="fw-semibold">
              {regions.slice(1).map((region, index) => (
                region.trim()
              )).join('\n')}
              </span>
            </Tooltip>
          }
        >
          <button className="btn btn-icon btn-sm">
            <span
              className="badge px-3 rounded-pill"
              style={{ border: "1px solid #E1E1E1" }}
            >
              +{regions.length - 1}
            </span>
          </button>
        </OverlayTrigger>
      )}

      {showAll && regions.slice(1).map((region, idx) => (
        <div key={idx} className="d-flex flex-stack my-1">
          <span className="text-muted fw-semibold">
            <span className="badge px-3 rounded-pill" style={{ border: "2px solid #E1E1E1" }}>
              {region.trim()}
            </span>
          </span>
        </div>
      ))}
    </>
  );
};